/* OPIA - the only JS the theme needs.
   Progressive enhancement: every one of these works without it, just less nicely. */
(function () {
  'use strict';

  /* ---- mobile nav drawer ------------------------------------------------
     A real <dialog>, so Escape and the focus trap come from the browser
     rather than from hand-rolled key handling. */
  var drawer = document.getElementById('nav-drawer');
  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) {
        if (typeof drawer.showModal === 'function') drawer.showModal();
        else drawer.classList.add('is-open');
      }
      if (e.target.closest('[data-drawer-close]')) {
        if (typeof drawer.close === 'function') drawer.close();
        else drawer.classList.remove('is-open');
      }
    });
  }

  /* ---- mega menu --------------------------------------------------------
     Opens on hover for pointers and on click/Enter for everyone else, so the
     panel is reachable from a keyboard. Escape closes and returns focus to the
     toggle, and a click outside closes it. */
  var toggles = document.querySelectorAll('[data-panel-toggle]');

  function closeAll(except) {
    toggles.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }

  function setOpen(toggle, open) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    if (open) closeAll(toggle);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  toggles.forEach(function (toggle) {
    var item = toggle.closest('.nav__item');
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));

    toggle.addEventListener('click', function () {
      setOpen(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });

    /* hover only where a pointer exists; it never becomes the only way in */
    if (window.matchMedia('(hover: hover)').matches && item && panel) {
      item.addEventListener('mouseenter', function () { setOpen(toggle, true); });
      [item, panel].forEach(function (el) {
        el.addEventListener('mouseleave', function () {
          setTimeout(function () {
            if (!item.matches(':hover') && !panel.matches(':hover')) setOpen(toggle, false);
          }, 80);
        });
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-panel-toggle][aria-expanded="true"]');
    if (open) { setOpen(open, false); open.focus(); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item--has-panel')) closeAll(null);
  });

  /* ---- variant picker ---------------------------------------------------
     Reads the variant straight off the form inputs and swaps the hidden id,
     the price and the button state. No fetch, so it cannot leave the page in
     a half-updated state if the network is slow. */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price]');

    function current() {
      return Array.from(form.querySelectorAll('[data-opt]:checked')).map(function (i) { return i.value; });
    }

    function update() {
      var chosen = current();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      if (!match) {
        button.disabled = true;
        button.textContent = button.dataset.unavailable;
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;

      button.disabled = !match.available;
      /* `data-add-text` -> dataset.addText. `dataset.add` reads the bare
         `data-add` marker attribute, which is an empty string, so getting this
         wrong silently blanks the button label on every in-stock variant. */
      button.textContent = match.available ? button.dataset.addText : button.dataset.soldout;

      /* keep the URL shareable without reloading */
      if (window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u);
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-opt]')) update();
    });
    update();
  });
})();

/* --------------------------------------------------------------------------
   Sticky header on the home page.

   The transparent header is absolutely positioned over the hero, so CSS
   `position: sticky` has nothing to stick to. Once the hero has scrolled past,
   the `--stuck` class switches it to fixed and it paints solid.

   The threshold is the hero's own height rather than a fixed number, so a tall
   banner and a short one both hand over at the right moment. Scroll work is
   kept off the scroll event itself via rAF; an IntersectionObserver would be
   neater but it cannot express "past the bottom of this element" without a
   sentinel node, and a sentinel is one more thing to go stale.
   -------------------------------------------------------------------------- */
(function () {
  var header = document.querySelector('[data-header].header--over');
  if (!header) return;

  var ticking = false;

  function threshold() {
    var hero = document.querySelector('.hero, .shopify-section:first-of-type');
    // Hand over just before the hero's bottom edge so the solid bar never
    // appears while a slice of banner is still showing behind it.
    var h = hero ? hero.getBoundingClientRect().height : 0;
    return Math.max(80, h - header.offsetHeight);
  }

  function apply() {
    ticking = false;
    header.classList.toggle('header--stuck', window.scrollY > threshold());
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();

/* Size guide dialog. Native <dialog> gives the focus trap, the Escape key and
   the inert background for free; this only wires the two buttons. */
(function () {
  var dlg = document.getElementById('size-guide');
  if (!dlg) return;
  var opener = document.querySelector('[data-sizeguide-open]');
  if (opener) {
    opener.addEventListener('click', function () {
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    });
  }
  dlg.addEventListener('click', function (e) {
    // Click outside the image closes it, matching how the drawer behaves.
    if (e.target === dlg) dlg.close();
  });
  var close = dlg.querySelector('[data-sizeguide-close]');
  if (close) close.addEventListener('click', function () { dlg.close(); });
})();

/* --------------------------------------------------------------------------
   Floating contact widget.

   Not a <dialog>: this panel must not take the page hostage — a visitor can
   keep scrolling and reading with it open, which a modal would prevent. So it
   is a plain disclosure, and the only things wired here are the toggle, the
   Escape key and a click outside.
   -------------------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-contact-widget]');
  if (!root) return;

  var toggle = root.querySelector('[data-cw-toggle]');
  var panel = root.querySelector('[data-cw-panel]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
  }

  toggle.addEventListener('click', function () {
    setOpen(panel.hidden);
    if (!panel.hidden) {
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
  });

  var closeBtn = root.querySelector('[data-cw-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setOpen(false);
      toggle.focus();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (!root.contains(e.target)) setOpen(false);
  });
})();

/* --------------------------------------------------------------------------
   Quick add from a product card.

   The markup is a real form whose submit buttons each carry a variant id, so
   without this script a click posts to /cart/add and the browser lands on the
   cart. All this does is keep the visitor where they were.

   The rule the whole thing is built around: NEVER tell someone an add failed
   unless we know it did. With no cart drawer, the badge is the only lasting
   sign anything happened, so a wrong "could not add" sends them to click again
   and buy a second pair. Three places that could have happened, and how each is
   handled:

   - the count refresh failing after a successful add. The add is committed
     first; the refresh runs separately and can only ever leave the count as it
     was.
   - the request being aborted or the network dropping, where we genuinely do
     not know. The cart is re-read and the count compared with what it was
     before the click: higher means it landed, and only an unchanged count gets
     a failure message - worded as uncertainty, not as a refusal.
   - a refusal from Shopify, which is the one case we can state plainly, so its
     own wording is used.

   The count guard counts READS, not adds. Keying it to adds meant a newer add
   that failed raised a high-water mark nothing could satisfy, and silently
   threw away the count from an older add that had succeeded.
   -------------------------------------------------------------------------- */
(function () {
  var forms = document.querySelectorAll('[data-qadd]');
  if (!forms.length) return;
  if (!window.fetch || !window.FormData) return;   // leave the plain form posts alone

  var cfg = document.querySelector('[data-cart-config]');
  if (!cfg) return;

  var ADD_URL = cfg.getAttribute('data-add-url');
  var CART_URL = cfg.getAttribute('data-cart-url');
  var TXT_ANNOUNCE = cfg.getAttribute('data-added-announce') || '';
  var TXT_FAILED = cfg.getAttribute('data-failed') || '';
  var TXT_UNSURE = cfg.getAttribute('data-unconfirmed') || TXT_FAILED;
  var TXT_ADDING = cfg.getAttribute('data-adding') || '';
  var SETTLE = 1600;
  var ERROR_HOLD = 4000;
  var DEADLINE = 10000;

  var live = document.querySelector('[data-cart-live]');
  var lastPressed = null;
  var latestRead = 0;          // guards the COUNT REFRESH, not the add

  // Captured before anything can overwrite it, so a failure message can be
  // shown in its place and the strip put back afterwards.
  Array.prototype.forEach.call(forms, function (f) {
    var l = f.querySelector('.qadd__label');
    if (l) l.setAttribute('data-default', l.textContent);
  });

  // Liquid renders every size focusable so that WITHOUT this script all eight
  // remain reachable by keyboard. The roving tabindex is an enhancement, so it
  // is applied here rather than baked into the markup.
  Array.prototype.forEach.call(forms, function (f) {
    var sizes = f.querySelectorAll('.qadd__size');
    var first = null;
    Array.prototype.forEach.call(sizes, function (b) { if (!first && !b.disabled) first = b; });
    Array.prototype.forEach.call(sizes, function (b) {
      b.setAttribute('tabindex', b === first ? '0' : '-1');
    });
  });

  function announce(msg) {
    if (!live || !msg) return;
    // Cleared first so an identical message still counts as a change and is read.
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function readCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? null : n;
  }

  /* Announced only once the add is KNOWN to have worked, so the drawer never
     slides open over a failure. The drawer listens for this; if the theme is
     ever shipped without it, nothing listens and nothing breaks. */
  function emitAdded() {
    var ev;
    try {
      ev = new CustomEvent('cart:added');
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('cart:added', false, false, null);
    }
    document.dispatchEvent(ev);
  }

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
  }

  /* Re-read the cart and publish the count. Returns the count, or null if the
     read itself failed - callers use that to tell "we know" from "we don't".
     Its own deadline, because the add's timer has already been cleared by the
     time this runs. */
  function refreshCount() {
    var mine = ++latestRead;
    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);
    return fetch(CART_URL, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        window.clearTimeout(timer);
        if (!cart) return null;
        // An older read must not overwrite a newer one's number.
        if (mine === latestRead) setCount(cart.item_count);
        return cart.item_count;
      })
      .catch(function () { window.clearTimeout(timer); return null; });
  }

  /* Roving tabindex: one tab stop per card, arrows to move. Disabled sizes are
     skipped rather than focused and announced as dead ends. */
  function sizesIn(toolbar) {
    return Array.prototype.filter.call(
      toolbar.querySelectorAll('.qadd__size'),
      function (b) { return !b.disabled; }
    );
  }

  function setStop(toolbar, btn) {
    Array.prototype.forEach.call(toolbar.querySelectorAll('.qadd__size'), function (b) {
      b.setAttribute('tabindex', b === btn ? '0' : '-1');
    });
  }

  function moveTo(toolbar, list, i) {
    var next = list[(i + list.length) % list.length];
    if (!next) return;
    setStop(toolbar, next);
    next.focus();
  }

  /* focusin rather than the arrow handler alone: a pointer click, a screen
     reader's default action and script focus all land here, so the tab stop
     follows the size last used instead of going stale on the first one. */
  document.addEventListener('focusin', function (e) {
    var btn = e.target.closest && e.target.closest('.qadd__size');
    if (!btn) return;
    var toolbar = btn.closest('[role="toolbar"]');
    if (toolbar) setStop(toolbar, btn);
  });

  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('.qadd__size');
    if (!btn) return;
    var toolbar = btn.closest('[role="toolbar"]');
    if (!toolbar) return;

    // Escape dismisses the strip. It is hover-triggered content that paints
    // over the photograph, and WCAG 1.4.13 wants a way to put it away that is
    // not "move the pointer off the card" - which at high magnification means
    // scrolling and losing your place.
    if (e.key === 'Escape') {
      var card = btn.closest('.card');
      if (card) {
        card.setAttribute('data-qadd-off', '');
        var title = card.querySelector('.card__title a');
        if (title) title.focus();     // never leave focus on a hidden control
      }
      return;
    }

    var list = sizesIn(toolbar);
    var i = list.indexOf(btn);
    if (i < 0) return;

    // Left/Right only. The toolbar declares itself horizontal, and swallowing
    // Up/Down would take page scrolling away from every focused size.
    if (e.key === 'ArrowRight') { e.preventDefault(); moveTo(toolbar, list, i + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); moveTo(toolbar, list, i - 1); }
    else if (e.key === 'Home') { e.preventDefault(); moveTo(toolbar, list, 0); }
    else if (e.key === 'End') { e.preventDefault(); moveTo(toolbar, list, list.length - 1); }
  });

  // Leaving the card re-arms it, so Escape hides this visit rather than for good.
  document.addEventListener('pointerleave', function (e) {
    var card = e.target.closest && e.target.closest('.card[data-qadd-off]');
    if (card) card.removeAttribute('data-qadd-off');
  }, true);

  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.qadd__size');
    if (b) lastPressed = b;
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('.qadd__size');
    if (b) lastPressed = b;
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-qadd]');
    if (!form) return;

    // No submitter and no record of a press means we cannot tell which size was
    // meant - so let the browser post it natively, which always carries the
    // clicked button's own name and value. Guessing here is how the wrong size
    // would get added.
    var btn = e.submitter || lastPressed;
    if (!btn || !form.contains(btn) || btn.disabled) return;

    e.preventDefault();

    // Busy, or still showing its tick. Without the second half a double click
    // adds the variant twice - the request finishes between the two clicks, so
    // aria-busy is already gone by the time the second one lands.
    if (btn.getAttribute('aria-busy') === 'true' || btn.hasAttribute('data-added')) return;
    btn.setAttribute('aria-busy', 'true');

    var size = btn.getAttribute('data-qadd-size') || '';
    var title = form.getAttribute('data-product-title') || '';
    var card = form.closest('.card');
    var label = form.querySelector('.qadd__label');
    var countBefore = readCount();

    var ctrl = window.AbortController ? new window.AbortController() : null;
    var deadline = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);

    function done() {
      window.clearTimeout(deadline);
      btn.removeAttribute('aria-busy');
    }

    function clearError() {
      if (card) card.removeAttribute('data-qadd-error');
      if (!label) return;
      window.clearTimeout(label._qaddReset);
      label.textContent = label.getAttribute('data-default') || '';
      label.removeAttribute('data-error');
    }

    function showError(msg) {
      announce(msg);
      if (!label) return;
      label.textContent = msg;
      label.setAttribute('data-error', '');
      // Pin the strip open. It is only visible while the card is hovered, so
      // without this the message appears under a pointer that has already moved
      // on and the failure is silent.
      if (card) card.setAttribute('data-qadd-error', '');
      window.clearTimeout(label._qaddReset);
      label._qaddReset = window.setTimeout(function () {
        label.textContent = label.getAttribute('data-default') || '';
        label.removeAttribute('data-error');
        if (card) card.removeAttribute('data-qadd-error');
      }, ERROR_HOLD);
    }

    function succeed() {
      // A success close behind a failure must take the red message with it, or
      // the card shows a tick and "could not add" side by side.
      clearError();
      btn.setAttribute('data-added', '');
      announce(TXT_ANNOUNCE.replace('__TITLE__', title).replace('__SIZE__', size));
      emitAdded();
      window.clearTimeout(btn._qaddSettle);
      btn._qaddSettle = window.setTimeout(function () {
        btn.removeAttribute('data-added');
      }, SETTLE);
    }

    announce(TXT_ADDING.replace('__SIZE__', size));

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.value), quantity: 1 }] }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        if (r.ok) return null;
        // Read the body for Shopify's own explanation before giving up on it.
        return r.json().catch(function () { return null; }).then(function (body) {
          var err = new Error('add ' + r.status);
          err.refused = true;                       // the server said no, definitively
          if (body && (body.description || body.message)) {
            err.shopifyDescription = body.description || body.message;
          }
          throw err;
        });
      })
      .then(function () {
        // 200: the shoe IS in the cart. Commit the success before anything else
        // runs, so nothing downstream can retract it.
        done();
        succeed();
        return refreshCount();
      })
      .catch(function (err) {
        done();

        if (err && err.refused) {
          showError(err.shopifyDescription || TXT_FAILED);
          refreshCount();
          return;
        }

        // Aborted or the network dropped: we do not know. Ask the cart.
        return refreshCount().then(function (now) {
          if (now !== null && countBefore !== null && now > countBefore) {
            succeed();                 // it landed after all
          } else {
            showError(TXT_UNSURE);     // worded as uncertainty, not refusal
          }
        });
      });
  });
})();

/* --------------------------------------------------------------------------
   Product gallery dots.

   The carousel itself is CSS - flex plus scroll-snap - so it swipes with or
   without this. All this adds is the position indicator, built here rather
   than rendered in Liquid so that with no JavaScript there are no dead buttons
   sitting under the photographs.
   -------------------------------------------------------------------------- */
(function () {
  var dots = document.querySelector('[data-gallery-dots]');
  var gallery = document.querySelector('.product__gallery');
  if (!dots || !gallery) return;

  var slides = Array.prototype.slice.call(gallery.children);
  if (slides.length < 2) return;

  var buttons = slides.map(function (slide, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'product__dot';
    b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + slides.length);
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    b.addEventListener('click', function () {
      // scrollIntoView on the slide keeps the snap maths in the browser rather
      // than duplicating it here, where it would drift from the CSS.
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
    dots.appendChild(b);
    return b;
  });

  function mark(i) {
    for (var n = 0; n < buttons.length; n++) {
      buttons[n].setAttribute('aria-current', n === i ? 'true' : 'false');
    }
  }

  // Which slide is showing is whichever is most in view. An observer rather
  // than a scroll handler, so it costs nothing while the page sits still.
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          mark(slides.indexOf(entry.target));
        }
      });
    }, { root: gallery, threshold: [0.6] });
    slides.forEach(function (s) { io.observe(s); });
  }
})();

/* --------------------------------------------------------------------------
   Add to cart from the product page, without leaving it.

   Adding used to post the form and land on /cart. That ended the visit to the
   page: choosing a second size meant going back, re-picking and adding again.
   Now the add happens in the background and the page stays exactly where it
   was, with the size buttons still under the cursor.

   The form is untouched markup that posts to /cart/add on its own, so with no
   JavaScript the old behaviour is still there and still correct.

   Same rule as the quick add on the cards: NEVER say an add failed unless we
   know it did. A wrong "could not add" sends someone back to click again and
   buy a second pair. So a 200 is committed immediately, a refusal is reported
   in Shopify's own words, and a dropped connection is resolved by re-reading
   the cart and comparing the count rather than by guessing.
   -------------------------------------------------------------------------- */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  if (!window.fetch || !window.FormData) return;   // leave the native post alone

  var cfg = document.querySelector('[data-cart-config]');
  if (!cfg) return;

  var ADD_URL = cfg.getAttribute('data-add-url');
  var CART_URL = cfg.getAttribute('data-cart-url');
  var TXT_FAILED = cfg.getAttribute('data-failed') || '';
  var TXT_UNSURE = cfg.getAttribute('data-unconfirmed') || TXT_FAILED;
  var TXT_NOTE = cfg.getAttribute('data-added-note') || '';

  var btn = form.querySelector('[data-add]');
  if (!btn) return;

  var note = form.querySelector('[data-add-note]');
  var noteText = form.querySelector('[data-add-note-text]');
  var live = document.querySelector('[data-cart-live]');

  var SETTLE = 2000;
  var DEADLINE = 10000;

  function announce(msg) {
    if (!live || !msg) return;
    // Cleared first so an identical message still counts as a change.
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function readCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? null : n;
  }

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
  }

  /* Its own deadline, because the add's timer is already cleared by the time
     this runs. Returns the count, or null when the read itself failed - which
     is how the caller tells "we know" from "we don't". */
  function refreshCount() {
    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);
    return fetch(CART_URL, {
      headers: { Accept: 'application/json' },
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        window.clearTimeout(timer);
        if (!cart) return null;
        setCount(cart.item_count);
        return cart.item_count;
      })
      .catch(function () { window.clearTimeout(timer); return null; });
  }

  function showNote(msg, isError) {
    if (!note) { announce(msg); return; }
    if (noteText) noteText.textContent = msg;
    if (isError) note.setAttribute('data-error', '');
    else note.removeAttribute('data-error');
    note.hidden = false;
    announce(msg);
  }

  /* See the quick add module: same event, same reason. */
  function emitAdded() {
    var ev;
    try {
      ev = new CustomEvent('cart:added');
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('cart:added', false, false, null);
    }
    document.dispatchEvent(ev);
  }

  var hasDrawer = !!document.querySelector('[data-cart-drawer]');

  function succeed() {
    /* Drawn OVER the button rather than replacing its label: the variant
       picker also writes to that label, and the two would fight. */
    btn.setAttribute('data-added', '');
    window.clearTimeout(btn._addedTimer);
    btn._addedTimer = window.setTimeout(function () {
      btn.removeAttribute('data-added');
    }, SETTLE);

    /* With the drawer present the cart itself slides open, which says
       "it is in" far better than a line of text under the button - so the
       note is not also shown. The announcement still is: the drawer is a
       visual event, and a screen reader needs telling in words. */
    if (hasDrawer) {
      announce(TXT_NOTE);
      emitAdded();
    } else {
      showNote(TXT_NOTE, false);
    }
  }

  form.addEventListener('submit', function (e) {
    // Only OUR add button is intercepted. Shopify's dynamic checkout button
    // lives in this same form, and swallowing its submit would break Buy it
    // now entirely - the shopper would press it and nothing would happen.
    if (e.submitter && e.submitter !== btn) return;
    if (btn.disabled) return;                  // sold out: let the form be
    e.preventDefault();

    // Busy, or still showing its tick - otherwise a double click adds twice,
    // the first request having finished between the two.
    if (btn.getAttribute('aria-busy') === 'true' || btn.hasAttribute('data-added')) return;
    btn.setAttribute('aria-busy', 'true');

    var countBefore = readCount();
    var ctrl = window.AbortController ? new window.AbortController() : null;
    var deadline = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);

    function done() {
      window.clearTimeout(deadline);
      btn.removeAttribute('aria-busy');
    }

    // The whole form, so the chosen variant id and anything added to it later
    // (line item properties, a quantity field) travel without this needing to
    // know they exist.
    fetch(ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        if (r.ok) return null;
        // Read the body for Shopify's own explanation before giving up on it.
        return r.json().catch(function () { return null; }).then(function (body) {
          var err = new Error('add ' + r.status);
          err.refused = true;                  // the server said no, definitively
          if (body && (body.description || body.message)) {
            err.shopifyDescription = body.description || body.message;
          }
          throw err;
        });
      })
      .then(function () {
        // 200: it IS in the cart. Commit before anything else can retract it.
        done();
        succeed();
        return refreshCount();
      })
      .catch(function (err) {
        done();

        if (err && err.refused) {
          showNote(err.shopifyDescription || TXT_FAILED, true);
          refreshCount();
          return;
        }

        // Aborted, or the network dropped: we genuinely do not know. Ask.
        return refreshCount().then(function (now) {
          if (now !== null && countBefore !== null && now > countBefore) succeed();
          else showNote(TXT_UNSURE, true);
        });
      });
  });
})();

/* --------------------------------------------------------------------------
   Cart quantity stepper.

   Plus and minus instead of selecting a digit and typing over it, and the
   totals settle without a page reload.

   The numbers come back from Shopify already formatted: the change request
   asks for this section to be re-rendered, and only the money elements are
   copied out of that HTML. Formatting paisa into "Rs 6,499.00" here would put
   a second money format in JavaScript, free to drift from the shop's own.

   Only the totals are swapped, never the controls - so the button just pressed
   is still the same element, still focused, and a second press lands where the
   first one did.

   Minus stops at 1. Falling through to 0 would delete the line, and a stepper
   that deletes on one extra tap is a bad surprise; Remove is right there.
   -------------------------------------------------------------------------- */
(function () {
  var form = document.querySelector('[data-cart-form]');
  if (!form) return;
  if (!window.fetch || !window.DOMParser) return;   // the Update button still works

  var cfg = document.querySelector('[data-cart-config]');
  if (!cfg) return;

  var CHANGE_URL = cfg.getAttribute('data-change-url');
  var CART_URL = cfg.getAttribute('data-cart-url');
  var TXT_FAILED = cfg.getAttribute('data-qty-failed') || '';
  var TXT_QTY = cfg.getAttribute('data-qty-announce') || '';
  if (!CHANGE_URL) return;

  var SECTION = form.getAttribute('data-cart-section');
  var live = document.querySelector('[data-cart-live]');
  var updateBtn = form.querySelector('[data-cart-update]');
  var DEADLINE = 10000;
  var busy = false;

  // Nothing left for Update to do once the steppers apply changes themselves.
  // Hidden here rather than in Liquid so it is still there without JavaScript.
  if (updateBtn) updateBtn.hidden = true;

  function announce(msg) {
    if (!live || !msg) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
  }

  /* Re-read the cart and make the row agree with it. The server is the only
     thing that knows the real quantity once a change has been refused. */
  function resync(row, key) {
    if (!CART_URL) return;
    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        setCount(cart.item_count);
        var line = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) line = cart.items[i];
        }
        var input = row.querySelector('[data-qty-input]');
        if (line) { if (input) input.value = line.quantity; }
        else if (row.parentNode) { row.parentNode.removeChild(row); return; }
        syncRow(row);
      })
      .catch(function () {});
  }

  /* Said out loud AND shown. The mismatch this reports is a visual one - a
     quantity that disagrees with a total - so a live region alone would leave
     a sighted shopper looking at two numbers and no explanation. */
  function showRowError(row, msg) {
    var box = row.querySelector('.cart__error');
    if (!box) {
      box = document.createElement('p');
      box.className = 'cart__error';
      (row.querySelector('.cart__controls') || row).appendChild(box);
    }
    box.textContent = msg;
    window.clearTimeout(box._t);
    box._t = window.setTimeout(function () {
      if (box.parentNode) box.parentNode.removeChild(box);
    }, 6000);
  }

  function syncRow(row) {
    if (!row) return;
    var input = row.querySelector('[data-qty-input]');
    var down = row.querySelector('[data-qty-step="-1"]');
    if (input && down) down.disabled = (parseInt(input.value, 10) || 0) <= 1;
  }

  /* Copy the money out of the freshly rendered section. Matched by line key
     rather than by position, because a line that reached 0 is gone from the
     new HTML and every index after it has shifted. */
  function applySection(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var sub = doc.querySelector('[data-cart-subtotal]');
    var mySub = form.querySelector('[data-cart-subtotal]');
    if (sub && mySub) mySub.textContent = sub.textContent;

    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-cart-line]'));
    for (var i = 0; i < rows.length; i++) {
      var key = rows[i].getAttribute('data-key');
      var fresh = doc.querySelector('[data-cart-line][data-key="' + key + '"]');
      if (!fresh) { rows[i].parentNode.removeChild(rows[i]); continue; }
      var a = fresh.querySelector('[data-line-total]');
      var b = rows[i].querySelector('[data-line-total]');
      if (a && b) b.textContent = a.textContent;
    }
    return true;
  }

  function change(row, qty, pressed) {
    var key = row.getAttribute('data-key');
    busy = true;
    row.setAttribute('aria-busy', 'true');

    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);

    var body = { id: key, quantity: qty };
    if (SECTION) body.sections = SECTION;

    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        if (r.ok) return r.json();
        // Shopify explains the refusal in the body - "All 1 Elara are in your
        // cart" and the like. That is worth showing: a bare "could not change"
        // leaves someone pressing a button that is never going to work.
        return r.json().catch(function () { return null; }).then(function (b) {
          var err = new Error('change ' + r.status);
          err.shopify = b && (b.description || b.message);
          throw err;
        });
      })
      .then(function (cart) {
        window.clearTimeout(timer);
        busy = false;
        row.removeAttribute('aria-busy');

        setCount(cart.item_count);

        if (cart.item_count === 0) { window.location.reload(); return; }

        var html = cart.sections && SECTION ? cart.sections[SECTION] : null;
        if (!applySection(html)) {
          // No rendered section came back, so the totals on screen are stale
          // and there is no honest way to correct them here. Reload rather
          // than leave wrong money in front of someone about to check out.
          window.location.reload();
          return;
        }

        var title = row.querySelector('.cart__name');
        announce(TXT_QTY
          .replace('__TITLE__', title ? title.textContent.trim() : '')
          .replace('__QTY__', qty));

        // Focus can land on a minus that just became disabled (quantity 1);
        // move it to the plus rather than letting it fall to the document.
        if (pressed && pressed.disabled) {
          var up = row.querySelector('[data-qty-step="1"]');
          if (up) up.focus();
        }
      })
      .catch(function (err) {
        window.clearTimeout(timer);
        busy = false;
        row.removeAttribute('aria-busy');

        var msg = (err && err.shopify) || TXT_FAILED;
        showRowError(row, msg);
        announce(msg);

        // NOT a remembered value. The click handler writes the new number into
        // the field before calling this, so anything captured here is already
        // the number we just put there - restoring it is a no-op, which is how
        // a rejected increase left the field reading 2 beside a total for 1.
        // Ask the cart what it actually holds instead; that is also correct
        // when the failure happened somewhere we cannot see.
        resync(row, key);
      });
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty-step]');
    if (!btn || btn.disabled || busy) return;

    var row = btn.closest('[data-cart-line]');
    var input = row && row.querySelector('[data-qty-input]');
    if (!input) return;

    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var next = (parseInt(input.value, 10) || 1) + step;
    if (next < 1) return;

    input.value = next;          // optimistic, reverted above if the call fails
    syncRow(row);
    change(row, next, btn);
  });

  // Typing into the field still works; it commits on blur, not on every
  // keystroke, so "12" is not read as a 1 on the way to 12.
  form.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-qty-input]');
    if (!input || busy) return;
    var row = input.closest('[data-cart-line]');
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) { n = 1; input.value = 1; }
    syncRow(row);
    change(row, n, null);
  });

  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-qty-input]');
    if (!input) return;
    e.preventDefault();          // do not submit the whole form
    input.blur();                // fires the change handler above
  });
})();

/* --------------------------------------------------------------------------
   Collection filters - size and colour.

   Built from the cards already on the page, so the options offered are always
   exactly the ones that exist in THIS collection: no empty "size 41" chip on a
   collection that has none, and nothing to maintain when stock changes.

   The card publishes only AVAILABLE variants (see product-card.liquid), so
   picking 38 shows the shoes buyable in 38 rather than the ones that merely
   list it. A filter that returns a grid of sold-out shoes is worse than none.

   Rendered here rather than in Liquid for the usual reason: with no JavaScript
   there must be no controls that cannot do anything. The bar simply never
   appears, and the full grid is already correct.

   Checkboxes inside a fieldset, not buttons with aria-pressed - a real control
   is already announced, grouped and operable by keyboard, and the chip styling
   rides on :checked.
   -------------------------------------------------------------------------- */
(function () {
  var host = document.querySelector('[data-filters]');
  var grid = document.querySelector('.grid');
  if (!host || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
  if (cards.length < 2) return;            // nothing worth filtering

  var T_SIZE = host.getAttribute('data-t-size') || 'Size';
  var T_COLOUR = host.getAttribute('data-t-colour') || 'Colour';
  var T_CLEAR = host.getAttribute('data-t-clear') || 'Clear all';
  var T_NONE = host.getAttribute('data-t-none') || '';

  /* "|35|36|" -> ["35","36"]. The pipes are what stop "Green" matching
     "Lime Green" further down, so they are kept on the card and only stripped
     when reading. */
  function values(card, attr) {
    var raw = card.getAttribute(attr) || '';
    return raw.split('|').filter(function (v) { return v !== ''; });
  }

  function collect(attr) {
    var seen = {};
    var out = [];
    cards.forEach(function (c) {
      values(c, attr).forEach(function (v) {
        if (!seen[v]) { seen[v] = true; out.push(v); }
      });
    });
    return out;
  }

  var sizes = collect('data-f-sizes');
  var colours = collect('data-f-colors');

  // Sizes are numbers and must not sort as text, or 42 lands before 5.
  sizes.sort(function (a, b) {
    var na = parseFloat(a), nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    return a.localeCompare(b);
  });
  colours.sort(function (a, b) { return a.localeCompare(b); });

  // One option in a group filters nothing - every card has it.
  var groups = [];
  if (sizes.length > 1) groups.push({ key: 'size', label: T_SIZE, attr: 'data-f-sizes', list: sizes });
  if (colours.length > 1) groups.push({ key: 'colour', label: T_COLOUR, attr: 'data-f-colors', list: colours });
  if (!groups.length) return;

  var bar = document.createElement('div');
  bar.className = 'filters__bar';

  groups.forEach(function (g) {
    var fs = document.createElement('fieldset');
    fs.className = 'filters__group';

    var lg = document.createElement('legend');
    lg.className = 'filters__legend';
    lg.textContent = g.label;
    fs.appendChild(lg);

    var wrap = document.createElement('div');
    wrap.className = 'filters__chips';

    g.list.forEach(function (v, i) {
      var id = 'f-' + g.key + '-' + i;

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'filters__input';
      input.id = id;
      input.value = v;
      input.setAttribute('data-f-group', g.key);

      var label = document.createElement('label');
      label.className = 'filters__chip';
      label.setAttribute('for', id);
      label.textContent = v;

      wrap.appendChild(input);
      wrap.appendChild(label);
    });

    fs.appendChild(wrap);
    bar.appendChild(fs);
  });

  var clear = document.createElement('button');
  clear.type = 'button';
  clear.className = 'filters__clear';
  clear.textContent = T_CLEAR;
  clear.hidden = true;
  bar.appendChild(clear);

  var status = document.createElement('p');
  status.className = 'filters__status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');

  host.appendChild(bar);
  host.appendChild(status);
  host.removeAttribute('hidden');

  function chosen(key) {
    return Array.prototype.slice
      .call(host.querySelectorAll('[data-f-group="' + key + '"]:checked'))
      .map(function (i) { return i.value; });
  }

  function apply() {
    var want = {};
    var any = false;
    groups.forEach(function (g) {
      want[g.key] = chosen(g.key);
      if (want[g.key].length) any = true;
    });

    var shown = 0;
    cards.forEach(function (card) {
      var ok = groups.every(function (g) {
        var picked = want[g.key];
        if (!picked.length) return true;           // this group is not narrowing
        var has = values(card, g.attr);
        // OR within a group, AND across groups: size 38 OR 39, AND pink.
        return picked.some(function (v) { return has.indexOf(v) !== -1; });
      });
      card.hidden = !ok;
      if (ok) shown++;
    });

    clear.hidden = !any;

    if (!any) status.textContent = '';
    else if (shown === 0) status.textContent = T_NONE;
    else status.textContent = shown + ' / ' + cards.length;
  }

  host.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-f-group')) apply();
  });

  clear.addEventListener('click', function () {
    Array.prototype.forEach.call(
      host.querySelectorAll('[data-f-group]'),
      function (i) { i.checked = false; }
    );
    apply();
    // Focus would otherwise sit on a button that just hid itself. The input is
    // visually hidden but still focusable, and the ring is drawn on its label.
    var first = host.querySelector('[data-f-group]');
    if (first) first.focus();
  });
})();

/* --------------------------------------------------------------------------
   Arrows for the customer-messages carousel.

   The track is already a scroll container with snap points, so it swipes on a
   phone and scrolls on a trackpad whether or not this runs. All this adds is a
   pair of arrows for a mouse, which is why they are created here rather than in
   Liquid - with no JavaScript there would otherwise be two buttons that scroll
   nothing.

   They are also only created when the track actually overflows, and they
   disappear again if it stops overflowing on resize. An arrow that cannot move
   anything is worse than no arrow.
   -------------------------------------------------------------------------- */
(function () {
  var box = document.querySelector('[data-chat-carousel]');
  var track = box && box.querySelector('[data-chat-track]');
  if (!box || !track) return;

  var cfg = document.querySelector('[data-cart-config]');
  var T_PREV = (cfg && cfg.getAttribute('data-chat-prev')) || 'Previous';
  var T_NEXT = (cfg && cfg.getAttribute('data-chat-next')) || 'Next';

  var ARROW =
    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 3l5 5-5 5"/></svg>';

  function overflows() {
    return track.scrollWidth - track.clientWidth > 4;
  }

  var prev = null, next = null;

  function build() {
    if (prev) return;

    prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'chat__nav chat__nav--prev';
    prev.setAttribute('aria-label', T_PREV);
    prev.innerHTML = ARROW;
    prev.style.transform = 'translateY(-50%) rotate(180deg)';

    next = document.createElement('button');
    next.type = 'button';
    next.className = 'chat__nav chat__nav--next';
    next.setAttribute('aria-label', T_NEXT);
    next.innerHTML = ARROW;

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });

    box.appendChild(prev);
    box.appendChild(next);
  }

  function destroy() {
    if (!prev) return;
    prev.remove();
    next.remove();
    prev = next = null;
  }

  /* One card plus the gap, read off the DOM rather than hard-coded, so the
     card width can change in CSS without this drifting from it. */
  function step() {
    var card = track.querySelector('.chat__card');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function page(dir) {
    track.scrollBy({
      left: step() * dir,
      // 'instant', NOT 'auto': per spec 'auto' means "use the CSS value",
      // and the CSS value here is smooth - so 'auto' would have animated for
      // exactly the people who asked for no animation.
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'instant' : 'smooth'
    });
  }

  function sync() {
    if (!overflows()) { destroy(); return; }
    build();
    var max = track.scrollWidth - track.clientWidth;
    // The track rests at its own padding-left, not at 0: snap aligns the
    // first card to the scrollport, which starts inside that padding. A
    // plain `<= 2` therefore never fired and Previous sat enabled at the
    // start, pointing nowhere.
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    prev.disabled = track.scrollLeft <= pad + 2;
    next.disabled = track.scrollLeft >= max - 2;
  }

  track.addEventListener('scroll', sync, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
  else window.addEventListener('resize', sync);

  // Images land after this runs and change the track's width.
  window.addEventListener('load', sync);
  sync();
})();


/* --------------------------------------------------------------------------
   Cart drawer.

   Adding used to leave the shopper looking at a line of text under the button.
   Now the cart slides in, shows what is in it, and offers Checkout - the whole
   point being that the next step is visible without a page load.

   Three rules carried over from the cart page, all of them learned the hard
   way:

   1. NEVER guess at the result of a change. Every quantity change and every
      removal is resolved by re-rendering from Shopify, so what the panel shows
      is the cart's own truth rather than a number this script remembered. An
      earlier stepper rolled back to a "previous value" it had already
      overwritten, and showed 2 beside a total for 1.
   2. Money is never formatted here. The re-render arrives already formatted by
      the shop.
   3. Everything degrades. No <dialog>, no fetch, no script at all - the cart
      icon is still a link to /cart, Remove is still a link, Checkout is still
      a form post.
   -------------------------------------------------------------------------- */
(function () {
  var dlg = document.querySelector('[data-cart-drawer]');
  if (!dlg) return;
  if (typeof dlg.showModal !== 'function') return;   // no dialog support: leave the links alone
  if (!window.fetch || !window.DOMParser) return;

  var cfg = document.querySelector('[data-cart-config]');
  if (!cfg) return;

  var CHANGE_URL = cfg.getAttribute('data-change-url');
  var TXT_FAILED = cfg.getAttribute('data-qty-failed') || '';
  var SECTION = 'cart-drawer';
  var DEADLINE = 10000;

  var live = document.querySelector('[data-cart-live]');
  var errorBox = dlg.querySelector('[data-cd-error]');
  var busy = false;
  var opener = null;
  var latest = 0;        // guards against an older re-render landing last

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function announce(msg) {
    if (!live || !msg) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function showError(msg) {
    if (!errorBox) { announce(msg); return; }
    errorBox.textContent = msg;
    errorBox.hidden = false;
    announce(msg);
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.textContent = '';
    errorBox.hidden = true;
  }

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n;
      if (n > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
  }

  function rowFor(key) {
    var rows = dlg.querySelectorAll('[data-cd-line]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') === key) return rows[i];
    }
    return null;
  }

  /* Focus has to land somewhere inside the dialog or the browser's focus trap
     has nothing to trap. The control that was pressed is gone after a
     re-render, so the equivalent one is found again by line key - and when the
     line itself has gone, the close button takes it. */
  function restoreFocus(key, selector) {
    var el = null;
    if (key && selector) {
      var row = rowFor(key);
      if (row) el = row.querySelector(selector);
    }
    if (!el || el.disabled) el = dlg.querySelector('[data-cart-drawer-close]');
    if (el) { try { el.focus(); } catch (e) {} }
  }

  /* Re-render from Shopify. Resolves true when the panel now shows the cart. */
  function refresh() {
    var mine = ++latest;
    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);
    var url = window.location.pathname + '?sections=' + SECTION;

    /* Deliberately NO Accept: application/json. On a collection or product
       URL that header makes Shopify answer with the RESOURCE as JSON and
       ignore ?sections= entirely - the drawer then refreshed itself from a
       collection object and silently rendered nothing. */
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        window.clearTimeout(timer);
        if (mine !== latest) return false;          // a newer change won
        if (!data || !data[SECTION]) return false;
        var doc = new DOMParser().parseFromString(data[SECTION], 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-contents]');
        var target = dlg.querySelector('[data-cart-drawer-contents]');
        if (!fresh || !target) return false;
        target.innerHTML = fresh.innerHTML;
        return true;
      })
      .catch(function () { window.clearTimeout(timer); return false; })
      .then(function (ok) {
        if (mine === latest) dlg.removeAttribute('data-loading');
        return ok;
      });
  }

  function open(from) {
    clearError();
    if (!dlg.open) {
      opener = from || document.activeElement;
      dlg.removeAttribute('data-closing');
      try { dlg.showModal(); } catch (e) { return; }
    }
    /* Always re-read on open. The panel was rendered when the page loaded, and
       anything added since - from a card, in another tab - is not in it. */
    dlg.setAttribute('data-loading', '');
    refresh();
  }

  function close() {
    if (!dlg.open) return;
    if (reduced()) { dlg.close(); return; }
    if (dlg.hasAttribute('data-closing')) return;
    dlg.setAttribute('data-closing', '');
    var fired = false;
    function done() {
      if (fired) return;
      fired = true;
      dlg.removeAttribute('data-closing');
      dlg.close();
    }
    // The timer is the one that matters: if the animation never fires its end
    // event the panel must still shut, or it is stuck open over the page.
    var t = window.setTimeout(done, 400);
    dlg.addEventListener('animationend', function h(ev) {
      if (ev.target !== dlg) return;
      dlg.removeEventListener('animationend', h);
      window.clearTimeout(t);
      done();
    });
  }

  dlg.addEventListener('close', function () {
    dlg.removeAttribute('data-closing');
    dlg.removeAttribute('data-loading');
    if (opener && document.contains(opener)) {
      try { opener.focus(); } catch (e) {}
    }
    opener = null;
  });

  // Escape: animate out rather than vanishing, but never block the close.
  dlg.addEventListener('cancel', function (e) {
    if (reduced()) return;
    e.preventDefault();
    close();
  });

  /* The header cart icon. Still a real link, so a middle click, ctrl-click or
     "open in new tab" goes to /cart as it always did. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cart-link]');
    if (!link) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open(link);
  });

  document.addEventListener('cart:added', function () { open(null); });

  // Backdrop. On a modal dialog the backdrop IS the dialog element, so a click
  // that lands on the panel itself never reaches here.
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) close();
  });

  dlg.addEventListener('click', function (e) {
    var closer = e.target.closest && e.target.closest('[data-cart-drawer-close]');
    if (closer) { e.preventDefault(); close(); }
  });

  /* The one request. Quantity 0 is a removal - Shopify treats it as one, so
     there is no second code path to keep in step. */
  function change(key, qty, focusSel, failMsg) {
    if (busy) return;
    busy = true;
    clearError();
    dlg.setAttribute('data-loading', '');

    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) ctrl.abort(); }, DEADLINE);

    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return null; }).then(function (body) {
          var err = new Error('change ' + r.status);
          err.refused = true;
          if (body && (body.description || body.message)) {
            err.shopifyDescription = body.description || body.message;
          }
          throw err;
        });
      })
      .then(function (cart) {
        window.clearTimeout(timer);
        setCount(cart.item_count);
        return refresh().then(function () { restoreFocus(key, focusSel); });
      })
      .catch(function (err) {
        window.clearTimeout(timer);
        /* Whatever went wrong, the panel is rebuilt from the cart rather than
           rolled back to a remembered number. If the change DID land before
           the connection dropped, the shopper sees that; if it did not, they
           see that instead. Either way it is true. */
        return refresh().then(function () {
          restoreFocus(key, focusSel);
          showError((err && err.shopifyDescription) || failMsg || TXT_FAILED);
        });
      })
      .then(function () {
        busy = false;
        dlg.removeAttribute('data-loading');
      });
  }

  dlg.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-cd-step]');
    if (step) {
      if (step.disabled || busy) return;
      var row = step.closest('[data-cd-line]');
      var input = row && row.querySelector('[data-cd-input]');
      if (!row || !input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-cd-step'), 10);
      // Minus stops at 1. Remove is right there and is not a mis-tap away.
      if (next < 1) return;
      input.value = next;          // shown at once; the re-render is the truth
      change(row.getAttribute('data-key'), next,
             '[data-cd-step="' + step.getAttribute('data-cd-step') + '"]');
      return;
    }

    var rm = e.target.closest && e.target.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();          // the href is the no-JS path
      if (busy) return;
      var r2 = rm.closest('[data-cd-line]');
      if (!r2) return;
      change(r2.getAttribute('data-key'), 0, null, TXT_FAILED);
    }
  });

  // Typed quantities commit on blur, not per keystroke, so "12" is not read as
  // a 1 on the way to 12.
  dlg.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cd-input]');
    if (!input || busy) return;
    var row = input.closest('[data-cd-line]');
    if (!row) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 1) { n = 1; input.value = 1; }
    change(row.getAttribute('data-key'), n, '[data-cd-input]');
  });
})();
